export * as coupons from '@wix/auto_sdk_marketing_coupons/meta';
export * as marketingConsent from '@wix/auto_sdk_marketing_marketing-consent/meta';
export * as adsTxt from '@wix/auto_sdk_marketing_ads-txt/meta';
